module.exports = __webpack_public_path__ + "media/images/service/f_bg-fd18d37ae0a1664f036a72ea98ba3b8b.png";